import { cropUrl } from './images.js'
import { ORGANIZATION_NAME, buildPublisherNode } from './seo.js'
import { toSlug } from './slug.js'

export const VEHICLE_ROUTE_NAME = 'recherche-led-accessoires-brand-type-typeid'

const DEFAULT_LOCALE = 'fr'

const MERCEDES_C_CLASS_W204 = {
  fr: 'Classe C (W204)',
  de: 'Klasse C (W204)',
  en: 'C-Class (W204)',
  es: 'Clase C (W204)',
  ja: 'C-Class (W204)',
  it: 'Classe C (W204)',
  nl: 'C-Klasse (W204)',
  pt: 'Classe C (W204)',
  pl: 'Klasa C (W204)',
  sv: 'C-Klass (W204)',
  cs: 'Třída C (W204)',
  ro: 'Clasa C (W204)',
  da: 'C-Klasse (W204)',
  el: 'C-Class (W204)',
  fi: 'C-luokka (W204)',
  no: 'C-Klasse (W204)',
}

const VOLKSWAGEN_CADDY_4_ESTATE = {
  fr: 'Caddy 4 Break',
  de: 'Caddy 4 Kombi',
  en: 'Caddy 4 Estate',
  es: 'Caddy 4 Break',
  ja: 'Caddy 4 Estate',
  it: 'Caddy 4 Station Wagon',
  nl: 'Caddy 4 Break',
  pt: 'Caddy 4 Break',
  pl: 'Caddy 4 Kombi',
  sv: 'Caddy 4 Kombi',
  cs: 'Caddy 4 Kombi',
  ro: 'Caddy 4 Break',
  da: 'Caddy 4 Stationcar',
  el: 'Caddy 4 Estate',
  fi: 'Caddy 4 Farmari',
  no: 'Caddy 4 Stasjonsvogn',
}

export const REALISATIONS = {
  22: {
    vehicle: 'MINI Cooper D (R56)',
    kind: 'car',
    rewrittenOn: '2026-10-13',
    cover:
      'mini-cooper-d-r56-feu-de-route-led-phare-additionnel-agmvision-615de62509716.jpg',
    catalogue: { id: 1024731, brand: 'MINI', name: 'MINI (R56)' },
    measures: {
      distance: 4,
      rows: [
        { zone: 'lowBeam', before: 605, after: 1899 },
        { zone: 'highBeam', before: 3861, after: 7758 },
      ],
      combined: { zone: 'highBeamAndDrivingLights', value: 10504 },
    },
  },
  23: {
    vehicle: 'Dodge RAM 5.7 V8 Hemi',
    kind: 'car',
    rewrittenOn: '2026-10-13',
    cover: 'dodge-ram-v8-hemi-full-led-avant-apres-agmvision-615f3bebcf025.jpg',
    catalogue: { id: 1053878, brand: 'DODGE', name: 'RAM 1500 DS/DJ' },
  },
  25: {
    vehicle: 'Honda CB1000R',
    kind: 'motorcycle',
    rewrittenOn: '2026-10-13',
    cover:
      'honda-cb1000r-moto-avant-apres-halogene-vs-led-agmvision-6161bde5b3fe6.jpg',
    catalogue: { id: 1043045, brand: 'HONDA', name: 'CB 1000 R (SC60)' },
  },
  28: {
    vehicle: 'Audi S1 2.0 TFSI Quattro',
    kind: 'car',
    rewrittenOn: '2026-10-13',
    cover:
      'audi-s1-faisceau-feux-de-route-xenon-d3s-5500k-agmvision-1-617505ba25ff2.jpg',
    catalogue: {
      id: 1013330,
      brand: 'AUDI',
      name: 'A1 (8X1, 8XK)',
    },
  },
  17: {
    vehicle: 'Lotus Exige 380 Sport',
    kind: 'car',
    rewrittenOn: '2026-10-13',
    cover: 'full-led-lotus-exige-614179f80464b.jpg',
    catalogue: { id: 1054026, brand: 'LOTUS', name: 'Exige S3' },
  },
  18: {
    vehicle: 'Honda Civic IX Type R',
    kind: 'car',
    rewrittenOn: '2026-10-13',
    cover: 'full-led-honda-civic-type-r-6145fafc760d0.jpg',
    catalogue: { id: 1019083, brand: 'HONDA', name: 'Civic 9 (FK)' },
  },
  19: {
    vehicle: 'Mercedes C63 AMG',
    kind: 'car',
    rewrittenOn: '2026-10-13',
    cover: 'mercedes-c63-amg-complete-full-led-agm-vision-1-6146ec9c584a5.jpg',
    catalogue: {
      id: 1023331,
      brand: 'MERCEDES-BENZ',
      name: MERCEDES_C_CLASS_W204,
    },
  },
  24: {
    vehicle: 'Yamaha XJ600',
    kind: 'motorcycle',
    rewrittenOn: '2026-10-13',
    cover:
      'yamaha-xj600-2013-moto-led-feux-de-route-agmvision-6161b5fa71b14.jpg',
    catalogue: {
      id: 1053167,
      brand: 'YAMAHA',
      name: 'XJ6 600 (RJ22)',
    },
  },
  26: {
    vehicle: 'Volkswagen Caddy IV',
    kind: 'car',
    rewrittenOn: '2026-10-13',
    cover:
      'volkswagen-caddy-veilleuse-led-mode-us-orange-agmvision-616313468b0f9.jpg',
    catalogue: {
      id: 1034062,
      brand: 'VOLKSWAGEN (VW)',
      name: VOLKSWAGEN_CADDY_4_ESTATE,
    },
  },
  1: {
    vehicle: 'Suzuki GSX-R 600 (2007)',
    kind: 'motorcycle',
    rewrittenOn: '2026-10-13',
    cover: 'dsc-3147b.jpg',
    catalogue: {
      id: 1051318,
      brand: 'SUZUKI',
      name: 'GSX-R 600 (CE1111)',
    },
    measures: {
      distance: 4,
      rows: [
        { zone: 'lowBeam', before: 749, after: 1526 },
        { zone: 'highBeam', before: 1016, after: 2121 },
      ],
    },
  },
  16: {
    vehicle: 'Chevrolet Camaro',
    kind: 'car',
    rewrittenOn: '2026-10-13',
    catalogue: null,
    selfFitted: true,
  },
}

export const realisationEntry = id => REALISATIONS[id] || null

const localizedName = (name, locale) =>
  typeof name === 'string' ? name : name[locale] || name[DEFAULT_LOCALE]

export function realisationVehicleRoute(id, locale) {
  const catalogue = realisationEntry(id)?.catalogue
  if (!catalogue) return null
  return {
    name: VEHICLE_ROUTE_NAME,
    params: {
      brand: toSlug(catalogue.brand).toLowerCase(),
      type: toSlug(localizedName(catalogue.name, locale)).toLowerCase(),
      typeid: catalogue.id,
    },
  }
}

export function realisationForVehicle(vehicleId) {
  const match = Object.entries(REALISATIONS).find(
    ([, entry]) => entry.catalogue && entry.catalogue.id === Number(vehicleId)
  )
  return match ? Number(match[0]) : null
}

export const realisationMeasures = id => realisationEntry(id)?.measures || null

export const measureFactor = ({ before, after }) =>
  Math.round((after / before) * 10) / 10

export const measureShare = (value, max) =>
  max > 0 ? Math.round((value / max) * 1000) / 10 : 0

const fileName = image =>
  String(image?.url_template || image?.url || '')
    .split('?')[0]
    .split('/')
    .pop()

export const realisationImages = images =>
  (images || []).filter(image => image?.url || image?.url_template)

export function realisationCover(id, images) {
  const usable = realisationImages(images)
  const cover = realisationEntry(id)?.cover
  return (
    (cover && usable.find(image => fileName(image) === cover)) ||
    usable[0] ||
    null
  )
}

export const carouselRealisations = (articles, currentId = null) =>
  (articles || []).filter(
    article =>
      article.id !== currentId && !realisationEntry(article.id)?.selfFitted
  )

export const realisationHeroSources = image => ({
  mobile: cropUrl(image, 780, 900, image.extension, 78),
  desktop: cropUrl(image, 1920, 1080, image.extension, 80),
})

export const realisationDateModified = (entry, updatedAt) =>
  entry?.rewrittenOn || updatedAt

export const realisationShareImage = image =>
  image ? cropUrl(image, 1200, 675, image.extension, 82) : null

export function realisationArticleData({
  baseUrl,
  url,
  locale,
  headline,
  description,
  image,
  dateModified,
}) {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline,
    inLanguage: locale,
    dateModified,
    author: { '@type': 'Organization', name: ORGANIZATION_NAME, url: baseUrl },
    publisher: buildPublisherNode(baseUrl),
    mainEntityOfPage: { '@type': 'WebPage', '@id': url },
    url,
  }
  if (description) {
    data.description = description
  }
  if (image) {
    data.image = image.startsWith('http') ? image : `${baseUrl}${image}`
  }
  return data
}
